export default {
  buttons: {
    go_to_basket: 'Naar winkelwagen',
  },
};
